<template>
  <div class="menu custom-menu">
    <div
      class="left_side"
      :style="theme.left.image == '' ? leftColor : leftImage"
    ></div>
    <div class="body">
      <div class="items">
        <template v-for="(section, index) in listSections">
          <div
            class="section"
            :key="`${index}_sections_menu`"
            @click="selected = index"
            :style="sectionColor"
          >
            <span v-text="section.title">{{ section.title }}</span>
          </div>
          <div class="subsections" :key="`${index}_sub_section`">
            <div
              v-for="(subsection, indexSubCategorie) in section.sub_sections"
              :key="indexSubCategorie"
            >
              <div
                class="subsection_suctom"
                @click="
                  sub_selected = indexSubCategorie;
                  collapsedArray(indexSubCategorie, index);
                "
                v-if="showSub(subsection)"
              >
                <span
                  v-text="
                    subsection.title == 'null-sub-sections'
                      ? ''
                      : subsection.title
                  "
                  >{{ subsection.title }}</span
                >
              </div>
              <template
                v-if="
                  showSub(subsection) && vIfcollapsed(indexSubCategorie, index)
                "
              >
                <div
                  class="item my_item_"
                  @click="
                    (e) => {
                      addToCart(item, e);
                    }
                  "
                  v-for="(item, indiceItem) in subsection.items"
                  :key="`${indiceItem}_item`"
                  :style="itemColor"
                >
                  <div class="infos">
                    <span class="title" v-text="item.title">{{
                      item.title
                    }}</span>
                    <span class="description" v-text="item.observation">{{
                      item.observation
                    }}</span>
                  </div>
                  <div class="d-flex price-custom">
                    <div class="price" v-text="`${item.price}`">
                      {{ item.price }}
                    </div>
                    <div>
                      {{ currentCurrency.symbol }}
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div
      class="right_side"
      :style="theme.right.image == '' ? rightColor : rightImage"
    ></div>
  </div>
</template>

<script>
export default {
  computed: {
    leftColor: function() {
      return {
        "background-color": this.theme.left.color,
      };
    },
    leftImage: function() {
      return {
        "background-image": `url(${this.theme.left.image})`,
      };
    },
    rightColor: function() {
      return {
        "background-color": this.theme.right.color,
      };
    },
    rightImage: function() {
      return {
        "background-image": `url(${this.theme.right.image})`,
      };
    },
    itemColor: function() {
      return {
        // "background-color": this.theme.header.color,
        "border-color": this.theme.header.color,
      };
    },
    sectionColor: function() {
      return {
        "background-color": this.theme.header.color,
      };
    },

    footerColor: function() {
      return {
        "background-color": this.theme.footer.color,
      };
    },
    footerImage: function() {
      return {
        "background-image": `url(${this.theme.right.image})`,
      };
    },
  },
  components: {},
  props: [
    "theme",
    "smaler",
    "newItem",
    "newSection",
    "listSections",
    "changeSectionTitle",
    "changeSectionSubTitle",
    "setCurrentTab",
    "currentTab",
    "addItem",
    "newSubSection",
    "handleChangeShowSub",
    "disponibleItem",
    "showItem",
    "changeItemObservation",
    "changeItemPrice",
    "changeItemTitle",
    "editCategorie",
    "deleteSection",
    "editSubCategorie",
    "deleteSubSection",
    "editItem",
    "deleteItem",
    "currentCurrency",
    "functionCollapsed",
    "addToCart",
  ],
  data() {
    return {
      collapsedArrayVar: [],
      selected: 0,
      sub_selected: 0,
    };
  },
  watch: {
    selected(newval) {
      // if(newVal!=this.currentTab){
      this.setCurrentTab(newval);
      // }
    },
    currentTab(newVal) {
      if (newVal != this.selected) {
        this.selected = newVal;
      }
    },
  },
  methods: {
    vIfcollapsed(indexSubCategorie, indexSection) {
      let searchedIndice = indexSection + "_" + indexSubCategorie;
      let item = this.collapsedArrayVar.find((item) => item == searchedIndice);
      if (item) {
        return true;
      } else {
        return false;
      }
    },
    collapsedArray(indexSubCategorie, indexSection) {
      let searchedIndice = indexSection + "_" + indexSubCategorie;

      if (this.collapsedArrayVar.includes(searchedIndice)) {
        this.collapsedArrayVar.splice(
          this.collapsedArrayVar.indexOf(searchedIndice),
          1
        );
      } else {
        this.collapsedArrayVar.push(searchedIndice);
      }
    },
    collapsed(index, selected) {
      this.functionCollapsed(index, selected);
      // this.$emit("functionCollapsed", index, selected);
    },
    deleteCategorie() {
      let old_selected = this.selected;
      if (this.selected != 0) {
        this.selected = this.selected - 1;
      }
      this.deleteSection(old_selected);
    },
    showSub(subSection) {
      // console.log(this.newItem[0].sections);
      // console.log(subSection);
      // console.log(this.listSections[this.selected].show_subCategories);
      if (this.listSections[this.selected].show_subCategories == undefined) {
        return true;
      }
      if (
        this.newItem[0].sections[this.selected].show_subCategories &&
        !subSection.defaultNonSub
      ) {
        return true;
      } else if (
        !this.newItem[0].sections[this.selected].show_subCategories &&
        subSection.defaultNonSub
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style>
@import url("../styles/customTheme/body.css");
</style>
